// extracted by mini-css-extract-plugin
module.exports = {"text":"AnimateText-module--text--1jFz3","visible":"AnimateText-module--visible--Iya8U"};